import AuthService from "../auth/AuthService";
import api from "../../api/hbscan";
import ICompany, { IEditCompanyRequest } from "../../models/company";

class CompanyService {
    GetCompanyByUser = async () => {
        const URI = "/api/hbscan/Company/GetCompanyByUser";
        return (
            await api.get<ICompany>(
                URI,
                {
                    headers: { Authorization: AuthService.guid },
                }
            )
        ).data;
    };

    PutCompany = async (company: IEditCompanyRequest) => {
        const URI = "/api/hbscan/Company/PutCompany";
        return (
            await api.put<void>(
                URI,
                company,
                {
                    headers: { Authorization: AuthService.guid },
                }
            )
        );
    };
}

const companyService = new CompanyService();

export default companyService;
